import API_URL from "@/globals/api";
import authHeader from "./auth-header";
import axiosInstance from "./api";

class InvoiceService {
  getInvoices() {
    return axiosInstance
      .get(`${API_URL}/invoices/get`, {
        headers: {
          "Content-Type": "application/json",
          ...authHeader()
        },
      })
  }
}

export default new InvoiceService();
